<div class="page-setting">
  <div class="center-align">
    <!-- <h1>Profile</h1> -->
    <img [src]="userProfileImageURL" class="profile-image">
    <br>
    <sh-text class="username-text">{{user.name}}</sh-text>
  </div>
  <br>
  <div class="setting-section">
    <div class="left-padding">
      <sh-text class="setting-text-font">Default Setting</sh-text>
    </div>
    <br>
    <div>
      <sh-icon class="default-setting-icon"
        button icon="information" onclick="notify('alert')"></sh-icon>
      <sh-text class="default-setting-text">Experienced User Mode</sh-text>
    </div>
    <div class="left-padding margin-bottom-5">
      <sh-toggle class="toggle-setting" [label]=experiencedMode [active]="experiencedMode === 'On'"
        (click)="changeUserMode(experiencedMode)" id="userModeButton"></sh-toggle>
    </div>

    <sh-icon _ngcontent-c8="" button="" icon="information" onclick="notify('alert')"
       class="default-setting-icon"></sh-icon>
    <sh-text class="default-setting-text">Default Model Quality</sh-text>
    <div class="left-padding toggle-setting">
      <sh-radio-group>
        <sh-radio-button label="High" [active]="modelQuality === 0" (click)="modelQuality = 0"></sh-radio-button>
        <sh-radio-button label="Medium" [active]="modelQuality === 1" disabled></sh-radio-button>
        <sh-radio-button label="Low" [active]="modelQuality === 2" disabled></sh-radio-button>
      </sh-radio-group>
    </div>

<!-- Theme Setting -->
    <sh-icon _ngcontent-c8="" button="" icon="information" onclick="notify('alert')"
     class="default-setting-icon"></sh-icon>
  <sh-text class="default-setting-text">Theme Setting</sh-text>
  <div class="left-padding toggle-setting">
    <sh-radio-group>
      <sh-radio-button label="Dark" [active]="themeType === 'dark'"  (click)="updateThemeSetting(themeType = 'dark')"></sh-radio-button>
      <sh-radio-button label="Light" [active]="themeType === 'light'" (click)="updateThemeSetting(themeType = 'light')"></sh-radio-button>
    </sh-radio-group>
  </div>

    
<ng-container *ngIf="loggendInUser.userGroup !== 'L2' && loggendInUser.userGroup !== 'L3'">
    <sh-icon _ngcontent-c8="" button="" icon="information" onclick="notify('alert')"
       class="default-setting-icon"></sh-icon>
    <sh-text class="default-setting-text">User Profile Settings</sh-text>
    <div class="left-padding">
      <br>
      <sh-checkbox id="cbRigged" label='Restrict other users to access my "All Model" page'
        [active]="userRestriction.allModels" (click)="changeCheckBoxValue(userRestriction,'allModels')"></sh-checkbox>
      <sh-checkbox id="cbRigged" label='Restrict other users to access my "Subscribed" page'
        [active]="userRestriction.subscribed" (click)="changeCheckBoxValue(userRestriction,'subscribed')"></sh-checkbox>
      <sh-checkbox id="cbRigged" label='Restrict other users to access my "Summary" page'
        [active]="userRestriction.summary" (click)="changeCheckBoxValue(userRestriction,'summary')"></sh-checkbox>

      <br>
  
      <sh-button color='primary' slot='footer' label='Apply' [disabled]="buttonClicked"(click)="updateUserRestrictionSettings()"></sh-button>
    </div>
  </ng-container>
  </div>
  <sh-notifications class="settings-notify">
    <sh-notification-item  [visible]='isShowNotificationSuccess'
    type = "confirmation"
    label = "Success"
    >
      {{showSuccessMessage}}
    </sh-notification-item> 
  </sh-notifications>

</div>